import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const Support = () => {
  return (
    <Typography
      sx={{ fontSize: "1rem", color: "#232323", align: "left", mt: 2 }}
    >
      To request access please lodge a service request <br />
      using <a
          href="https://urldefense.proofpoint.com/v2/url?u=https-3A__lendlease.service-2Dnow.com_lendlease-3Fid-3Dsc-5Fcat-5Fitem-26sys-5Fid-3D28b6f2231bdbed102cbba8a8b04bcb2a&d=DwMFAw&c=eIGjsITfXP_y-DLLX0uEHXJvU8nOHrUK8IrwNKOtkVU&r=1njzQesM7F6N40gFajuXkvwRxq8NsPbJk1qbzw_Y1Z0&m=iK4pQdDTCe67ujRXI3aDXOXkJedXUtmAL8suQPA3mr1QqYOjMEihMu9mDqb05g5h&s=_jv7HaslGYChsdYiiDDoz6y36_pCU7uKP2ideEKazFI&e="
          target="="
        >servicenow</a></Typography>
  );
};

export default Support;
